import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-group-editor',
  templateUrl: './group-editor.component.html',
  styleUrls: ['./group-editor.component.css']
})
export class GroupEditorComponent implements OnInit {

  @Input() LOB = "health";
  _groupData = [];
  _queueData = [];
  @Input() set groupData(value: any){
    this._groupData = value;
    this.formatGroups();
  }
  @Input() set queueData(value: any){
    this._queueData = value;
    this.formatGroups();
  }
  @Input() queueGroupId = "groupId";
  @Input() groupGroupId = "groupId";
  @Input() groupBlueprint = {};

  @Output() onGroupChange = new EventEmitter<any>();
  @Output() onQueueChange = new EventEmitter<any>();
  @Output() onButtonClick = new EventEmitter<any>();
  grouplessQueues = []

  editing: boolean = false;
  isValid: boolean = false;

  groups: Array<Object> = []

  openIndex: Number = -1;
  mouseIndex: Number = -1;
  mouseSubIndex:Number = -1;
  editIndex: Number = -1;
  editSubIndex: Number = -1;
  
  constructor() { }

  ngOnInit(): void {
    this.formatGroups()
  }

  //decides which group to have open, and toggle it if is alreadys
  toggleOpen(index){
    if(!this.editing){
      if(this.openIndex != index){
        this.openIndex = index;
      }
      else {
        this.openIndex = -1;
      }
    }
  }

  //Adds new group to list
  addGroup(){
    if(!this.editing){
      let testValue = {
        groupName: "",
        queues:[]
      }
      this.groups.push(testValue);
      this.editIndex = this.groups.length-1;
      this.openIndex = -1;
      this.editing = true;
    }
  }

  //deletes a group
  deleteGroup(num:number){
    this.onGroupChange.emit({action: 'delete', item: this._groupData[num]});
    this._groupData.splice(num, 1);
    this.formatGroups()  
  }

  //Edit group name
  editGroup(event: MouseEvent, i:number){
    event.stopPropagation();
    this.editIndex = i;
    this.editing = true;
  }

  //Add queue to group
  addQueue(group, index,i){
    event.stopPropagation();
    if(!this.editing && this.grouplessQueues.length>0){
      this.editing = true;
      this.openIndex = i;
      this.editSubIndex = index;
      let testValue = ""
      group.queues.push(testValue);
    }
    else if(this.grouplessQueues.length == 0){
      this.onQueueChange.emit({action: 'error', item: "No queue to Add"});
    }
  }

  //Delete queue from group, more accurately, it unassigns them from it
  deleteQueue(queue){
    for (let i=0;i<this._queueData.length;i++){
      if(this._queueData[i].queueName == queue){
        this._queueData[i][this.queueGroupId] = null;
        this.onQueueChange.emit({action: 'put', item: this._queueData[i]});
        console.log("deleted")
      }
    }
    this.formatGroups()  
  }

  //make changes to/new group permanent
  saveChanges(group){
    event.stopPropagation();
    this.editIndex = -1;
    this.editing = false;
    if(group[this.groupGroupId] == "" || !group[this.groupGroupId]){
      this._groupData.push({
        LOB: this.LOB,
        groupName: group.groupName,
        groupId: ""});
        this.onGroupChange.emit({action: 'put', item: this._groupData[this._groupData.length-1]});
    }
    else{
      for (let i=0;i<this._groupData.length;i++){
        if(this._groupData[i][this.groupGroupId] == group[this.groupGroupId]){
          this._groupData[i].groupName = group.groupName;
          this.onGroupChange.emit({action: 'put', item: this._groupData[i]});
        }
      }
    }
    
    this.formatGroups();
  }

  //make new queue permanent
  saveQueueChanges(queue, group){
    event.stopPropagation();
    this.editSubIndex = -1;
    this.editing = false;
    for (let i=0;i<this._queueData.length;i++){
      if(this._queueData[i].queueName == queue){
        this._queueData[i][this.queueGroupId] = group[this.groupGroupId];
        this.onQueueChange.emit({action: 'put', item: this._queueData[i]});
      }
    }
    this.formatGroups();
  }

  //Cancel edit/creating of something
  cancel(){
    event.stopPropagation();
    this.editIndex = -1;
    this.editSubIndex = -1;
    this.editing = false;
    this.formatGroups();
  }

  //Save changes and refresh 
  formatGroups(){
    this.groups = [];
    this.grouplessQueues = [];
    for (let i =0; i<this._groupData.length; i++){
      //Add the group's name,
      let newGroup = {
        groupName: this._groupData[i].groupName,
        groupId: this._groupData[i][this.groupGroupId],
        queues:[]
      }
      for (let j=0;j<this._queueData.length; j++){
        //If the queue matches the group
        if(this._queueData[j][this.queueGroupId] == this._groupData[i][this.groupGroupId]){
          //add it to the list
          // console.log(this._queueData[j])
          newGroup.queues.push(this._queueData[j].queueName)
        }
        //Catch all queues without a group, once each in a seperate list
        if(this._queueData[j][this.queueGroupId] == null && !this.grouplessQueues.includes(this._queueData[j].queueName)){
          this.grouplessQueues.push(this._queueData[j].queueName);
        }
      }
      //save this group
      this.groups.push(newGroup);
    }
  }
}
